import React from 'react';
import { Link } from '../Link.jsx';
import AuthorizedAction from '../AuthorizedAction.js';
import { getOrgSlug } from '../../lib/utils.js';

export const OrganizationLink = ({ ...props }) => (
  <Link route="organization/show" params={{ slug: getOrgSlug() }} {...props} />
);

export const EditOrganizationLink = ({ ...props }) => (
  <AuthorizedAction action="create" subject="group">
    <Link
      route="organization/edit"
      params={{ slug: getOrgSlug() }}
      {...props}
    />
  </AuthorizedAction>
);

export const OrganizationUsersLink = ({ ...props }) => (
  <Link route="organization/users" params={{ slug: getOrgSlug() }} {...props} />
);

export const OrganizationStakeholdersLink = ({ ...props }) => (
  <Link
    route="organization/stakeholders"
    params={{ slug: getOrgSlug() }}
    {...props}
  />
);

export const OrganizationEmployeesLink = ({ ...props }) => (
  <Link
    route="organization/employees"
    params={{ slug: getOrgSlug() }}
    {...props}
  />
);

export const CustomSettingsLink = ({ ...props }) => (
  <Link
    route="organization/custom-settings"
    params={{ slug: getOrgSlug() }}
    {...props}
  />
);

export const CustomProjectStatusesLink = ({ ...props }) => (
  <Link
    route="organization/custom-settings"
    params={{ slug: getOrgSlug() }}
    {...props}
  />
);
